import { Delete, Search } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material"
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SetFilter } from "../hooks/useContracts";

interface IContractsFilterProps {
  loading: boolean;
  setFilter: SetFilter;
}

const ContractsFilter: FC<IContractsFilterProps> = ({
  loading,
  setFilter
}) => {
  const { t } = useTranslation();
  
  const [text, setText] = useState('');

  useEffect(() => {
    // Debouncer when search parameters are entered
    if (text !== '') {
      const debounceForm = setTimeout(() => {
        console.debug("set", text);
        setFilter(cronstructFilter(text));
      }, 1500);
      
      return () => clearTimeout(debounceForm);
    } else {
      setFilter(text);
    }
  }, [text]);

  const cronstructFilter = (filter: string) => {
    const interpolatedFilter = `['|', ('name', 'like', '${filter}'), '|', ('cups.direccio', 'like', '${filter}'), '|', ('cups.name', 'like', '${filter}'), '|', ('tarifa', 'like', '${filter}'), ('llista_preu.name', 'like', '${filter}')]`;
    return interpolatedFilter;
  }

  return <TextField
      label={t("common:text.contracts_search_filter_info")}
      id="contract-list-search-filter"
      disabled={loading}
      variant='filled'
      sx={{width: {lg: "35vw", xs: "100%"}}}
      onChange={(event) => setText(event.target.value)}
      value={text}
      InputProps={{
        startAdornment: <InputAdornment position="start">
          <Search />
        </InputAdornment>,
        endAdornment: text && <InputAdornment position="end">
          <IconButton
            aria-label="remove search filter text"
            onClick={(_event) => setText('')}
            edge="end"
          >
            <Delete />
          </IconButton>
        </InputAdornment>
      }}
    />
}

export default ContractsFilter;